import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, filter, map, switchMap, take } from 'rxjs';
import { authVerifyAccessToken } from './state/auth.actions';
import { AUTH_HOME_PATH, AUTH_LOG_IN_PATH, AUTH_LOG_IN_URL_SEGMENT } from './state/auth.const';
import { AuthState } from './state/auth.state';

/**
 * Route guard that guarantees an authenticated session before activating a route.
 */
export const authGuard: CanActivateFn = (_, state): Observable<boolean | UrlTree> => {
  const store = inject(Store);
  const router = inject(Router);

  const isLoginUrl = (state.url ?? '').includes(AUTH_LOG_IN_URL_SEGMENT);

  return store.dispatch(new authVerifyAccessToken()).pipe(
    switchMap(() =>
      store.select(AuthState.refreshTokenLoadStatus).pipe(
        filter((refreshTokenLoadStatus) => refreshTokenLoadStatus?.status !== 'loading'),
        take(1)
      )
    ),
    switchMap(() => store.select(AuthState.isAuthenticated).pipe(take(1))),
    map((isAuthenticated) => {
      if (isAuthenticated) {
        if (isLoginUrl) return router.parseUrl(AUTH_HOME_PATH);
        return true;
      }
      if (isLoginUrl) return true;
      return router.parseUrl(AUTH_LOG_IN_PATH);
    })
  );
};
